import Config from './config'
import Phaser from 'phaser'
import {orbitTowable} from '../entity/utils'
// import {setOrbitingShipProp} from '../ship/utils'
import {setShipDestination} from '../ship/utils'
import audio from '../launch/audio'

// https://photonstorm.github.io/phaser3-docs/Phaser.Physics.Matter.MatterPhysics.html#overlap__anchor
export default function handleOverlap() {
    Object.keys(Config.ships).forEach((shipKey) => {
        const ship = Config.ships[shipKey]

        // Enemy ship is within friendly entity sensor
        Object.keys(Config.entities)
            .filter((key) => {
                const entity = Config.entities[key]
                return (
                    entity.faction === Config.userFactionName &&
                    !!entity.sensorCircle
                )
            })
            .forEach((key) => {
                if (ship.faction === Config.userFactionName) {
                    return
                }

                const entity = Config.entities[key]
                const shipInSensorRange = Phaser.Geom.Intersects.CircleToCircle(
                    ship.shipCircle,
                    entity.sensorCircle
                )

                if (!ship.isDetected) {
                    ship.isDetected = shipInSensorRange
                }
            })

        Object.keys(Config.ships).forEach((otherShipKey) => {
            const otherShip = Config.ships[otherShipKey]

            if (ship.faction === otherShip.faction) {
                return
            }

            const otherShipInSensorRange = Phaser.Geom.Intersects.CircleToCircle(
                ship.sensorCircle,
                otherShip.shipCircle
            )

            const otherShipInProximityRange = Phaser.Geom.Intersects.CircleToCircle(
                ship.proximityCircle,
                otherShip.shipCircle
            )

            if (!otherShip.isDetected) {
                otherShip.isDetected = otherShipInSensorRange

                // Play sound
                if (
                    otherShipInSensorRange &&
                    !Config.soundTriggers.shipSensorWarnSound
                ) {
                    Config.soundTriggers.shipSensorWarnSound = true
                    audio.shipSensor()
                }
            }

            if (otherShipInSensorRange && otherShipInProximityRange) {
                // Begin shooting
                ship.sprite.setAwake()
                ship.fighting = true
                ship.weaponTimer.paused = false
                if (!Object.keys(ship.weaponTargets).length) {
                    ship.weaponTargets[otherShip.id] = {
                        x: Config.ships[otherShip.id].x,
                        y: Config.ships[otherShip.id].y,
                    }
                }

                // Enemy ships follow friendly ships
                if (
                    ship.faction.includes(Config.enemyFactionName) &&
                    ship.type !== 'satellite' &&
                    !ship.orbitingEntity &&
                    !otherShip.orbitingEntity &&
                    otherShip.faction === Config.userFactionName &&
                    (!ship.following || ship.following === otherShip.id)
                ) {
                    const minDistance = ship.proximityCircle.radius / 2
                    if (
                        otherShip.x < ship.x - minDistance ||
                        otherShip.x > ship.x + minDistance ||
                        otherShip.y < ship.y - minDistance ||
                        otherShip.y > ship.y + minDistance
                    ) {
                        let x = otherShip.x
                        let y = otherShip.y
                        const dist = 3
                        if (otherShip.x < ship.x) {
                            x = x + ship.diameter * dist
                        }
                        if (otherShip.x > ship.x) {
                            x = x - ship.diameter * dist
                        }
                        if (otherShip.y < ship.y) {
                            y = y + ship.diameter * dist
                        }
                        if (otherShip.y > ship.y) {
                            y = y - ship.diameter * dist
                        }
                        if (!ship.following) {
                            ship.following = otherShip.id
                        }
                        setShipDestination({
                            ship,
                            x,
                            y,
                        })
                    }
                }
            }
        })
    })

    const bodies = Config.scene.matter.getMatterBodies()
    const entityOrbitBodies = bodies.filter(
        (body) => body[Config.namespace]?.isOrbitBody
    )
    // const userEntitySensorBodies = bodies.filter((body) => {
    //     const customProps = body[Config.namespace]
    //     const entity =
    //         customProps &&
    //         customProps.isEntitySensorBody &&
    //         Config.entities[customProps.entityId]
    //     return entity && entity.faction === Config.userFactionName
    // })
    const moveMarkerBodies = bodies.filter(
        (body) => body[Config.namespace]?.isMoveMarker
    )
    const shipBodies = bodies.filter(
        (body) => body[Config.namespace]?.isShipBody
    )
    // const undetectedEnemyShipBodies = shipBodies.filter((body) => {
    //     const ship = Config.ships[body[Config.namespace].shipId]
    //     // hide enemy ships, show them in entity/ship hit
    //     ship.isDetected = false
    //     setOrbitingShipProp(ship.id, 'isDetected', ship.isDetected)
    //     return ship.faction.includes(Config.enemyFactionName)
    // })
    // const shipSensorBodies = bodies.filter(
    //     (body) => body[Config.namespace]?.isShipSensorBody
    // )
    // const userShipSensorBodies = shipSensorBodies.filter(
    //     (body) =>
    //         Config.ships[body[Config.namespace].shipId].faction ===
    //         Config.userFactionName
    // )
    // const shipProximityBodies = bodies.filter(
    //     (body) => body[Config.namespace]?.isShipProximityBody
    // )
    const towableBodies = bodies.filter(
        (body) => body[Config.namespace]?.isTowableBody
    )
    // // Enemy ship is within friendly entity sensor
    // Config.scene.matter.overlap(
    //     undetectedEnemyShipBodies,
    //     userEntitySensorBodies,
    //     (shipBody, entitySensorBody) => {
    //         Config.ships[shipBody[Config.namespace].shipId].isDetected = true
    //     }
    // )
    // // Enemy Ship is within sensor range of friendly ship
    // Config.scene.matter.overlap(
    //     userShipSensorBodies,
    //     undetectedEnemyShipBodies,
    //     (shipSensorBody, enemyShipBody) => {
    //         // Play sound
    //         if (!Config.soundTriggers.shipSensorWarnSound) {
    //             Config.soundTriggers.shipSensorWarnSound = true
    //             audio.shipSensor()
    //         }
    //         Config.ships[
    //             enemyShipBody[Config.namespace].shipId
    //         ].isDetected = true
    //     }
    // )
    // // Ship proximity starts fight
    // Config.scene.matter.overlap(
    //     shipProximityBodies,
    //     shipBodies,
    //     (proximityBody, shipBody) => {
    //         const shipId = proximityBody[Config.namespace].shipId
    //         const ship = Config.ships[shipId]
    //         const otherShipId = shipBody[Config.namespace].shipId
    //         const otherShip = Config.ships[otherShipId]
    //         if (ship.id === otherShipId || ship.faction === otherShip.faction) {
    //             return
    //         }
    //         // Wake ships if sleep enabled
    //         // ship.sprite.setAwake()
    //         // otherShip.sprite.setAwake()
    //         // Begin shooting
    //         ship.fighting = true
    //         ship.weaponTimer.paused = false
    //         ship.weaponTargets[otherShipId] = {
    //             x: Config.ships[otherShipId].x,
    //             y: Config.ships[otherShipId].y,
    //         }
    //         // Enemy ships follow friendly ships
    //         if (
    //             ship.faction.includes(Config.enemyFactionName) &&
    //             ship.type !== 'satellite' &&
    //             !ship.orbitingEntity &&
    //             !otherShip.orbitingEntity &&
    //             otherShip.faction === Config.userFactionName &&
    //             (!ship.following || ship.following === otherShip.id)
    //         ) {
    //             const minDistance = ship.proximityBody.circleRadius / 2
    //             if (
    //                 otherShip.x < ship.x - minDistance ||
    //                 otherShip.x > ship.x + minDistance ||
    //                 otherShip.y < ship.y - minDistance ||
    //                 otherShip.y > ship.y + minDistance
    //             ) {
    //                 let x = otherShip.x
    //                 let y = otherShip.y
    //                 const dist = 3
    //                 if (otherShip.x < ship.x) {
    //                     x = x + ship.diameter * dist
    //                 }
    //                 if (otherShip.x > ship.x) {
    //                     x = x - ship.diameter * dist
    //                 }
    //                 if (otherShip.y < ship.y) {
    //                     y = y + ship.diameter * dist
    //                 }
    //                 if (otherShip.y > ship.y) {
    //                     y = y - ship.diameter * dist
    //                 }
    //                 if (!ship.following) {
    //                     ship.following = otherShip.id
    //                 }
    //                 setShipDestination({
    //                     ship,
    //                     x,
    //                     y,
    //                 })
    //             }
    //         }
    //     }
    // )
    // Entity detects ship then assigns ship to orbit
    // Move marker body is within entity orbit body
    Config.scene.matter.overlap(
        entityOrbitBodies,
        moveMarkerBodies,
        (orbitBody, moveMarkerBody) => {
            const {entityId} = orbitBody[Config.namespace]
            const entity = Config.entities[entityId]
            const {shipId} = moveMarkerBody[Config.namespace]
            const ship = Config.ships[shipId]
            const shipBody = ship.sprite.body
            // Ship body is within entity orbit body
            Config.scene.matter.overlap(
                orbitBody,
                shipBody,
                (orbitBody, shipBody) => {
                    // Assign ship to orbit
                    ship.orbitingEntity = entity
                    ship.graphics && ship.graphics.clear()
                    ship.moveMarker && ship.moveMarker.destroy()
                    ship.moving = false
                    // Ship is towing a towable, enter towable into orbit
                    if (
                        entity.type === 'planet' &&
                        entity.faction === Config.userFactionName
                    ) {
                        Object.keys(ship.towedTowables).forEach((towableId) => {
                            orbitTowable(entity, towableId)
                        })
                    } else {
                        ship.detachTowables()
                    }
                }
            )
        }
    )
    // Ship has hit a towable
    Config.scene.matter.overlap(
        shipBodies,
        towableBodies,
        (shipBody, towableBody) => {
            const {towableId} = towableBody[Config.namespace]
            const {shipId} = shipBody[Config.namespace]
            const towable = Config.towables[towableId]
            const ship = Config.ships[shipId]
            if (
                Object.keys(ship.towedTowables).length ===
                    Config.shipMaxTowables ||
                ship.faction.includes(Config.enemyFactionName)
            ) {
                return
            }
            towable.addConstraint(ship)
        }
    )
}
